if (!customElements.get('bz-banner-slider')) {
  class BzBannerSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.bz-banner__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-banner-dot]'));
      this.track = this.querySelector('.bz-banner__track');
      this.toggleBtn = this.querySelector('[data-banner-toggle]');
      this.index = 0;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.userPaused = false;
      if (this.slides.length < 2) return;

      this.querySelector('[data-banner-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-banner-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.bannerDot, 10), true)));
      this.toggleBtn?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.toggleBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.toggleBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
        this.userPaused ? this.pause() : this.play();
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.play();
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
        if (e.key === 'ArrowRight') this.go(this.index + 1, true);
      });
      document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.play()));

      this.initSwipe();
      this.initEditor();
      this.play();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    initSwipe() {
      let x0 = 0;
      let y0 = 0;
      let on = false;
      this.addEventListener('touchstart', (e) => {
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        on = true;
      }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (!on) return;
        on = false;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          this.swiped = true;
          setTimeout(() => (this.swiped = false), 60);
          this.go(this.index + (dx < 0 ? 1 : -1), true);
        }
      }, { passive: true });
      // A swipe must not also trigger the slide link.
      this.addEventListener('click', (e) => {
        if (this.swiped && e.target.closest('a')) e.preventDefault();
      }, true);
    }

    initEditor() {
      if (!window.Shopify || !Shopify.designMode) return;
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target);
        if (i > -1) {
          this.editorLock = true;
          this.pause();
          this.go(i);
        }
      });
      document.addEventListener('shopify:block:deselect', () => {
        this.editorLock = false;
        this.play();
      });
    }

    go(i, user) {
      const n = this.slides.length;
      const next = ((i % n) + n) % n;
      if (next === this.index) return;
      const prev = this.slides[this.index];
      const cur = this.slides[next];
      prev.classList.remove('is-active');
      prev.setAttribute('aria-hidden', 'true');
      prev.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
      cur.querySelectorAll('a').forEach((a) => a.removeAttribute('tabindex'));
      cur.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      // Warm the following slide too.
      this.slides[(next + 1) % n].querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      this.index = next;
      this.track.style.setProperty('--bz-banner-i', next);
      this.dots.forEach((d, k) => {
        d.classList.toggle('is-active', k === next);
        d.classList.remove('is-running');
        d.setAttribute('aria-selected', k === next ? 'true' : 'false');
      });
      if (user) {
        clearTimeout(this.timer);
        this.play();
      }
    }

    play() {
      if (!this.autoplay || this.userPaused || this.editorLock) return;
      this.classList.remove('is-paused');
      clearTimeout(this.timer);
      const dot = this.dots[this.index];
      if (dot) {
        dot.classList.remove('is-running');
        void dot.offsetWidth;
        dot.classList.add('is-running');
      }
      this.timer = setTimeout(() => {
        this.go(this.index + 1);
        this.play();
      }, this.speed);
    }

    pause() {
      clearTimeout(this.timer);
      this.classList.add('is-paused');
      this.dots.forEach((d) => d.classList.remove('is-running'));
    }
  }
  customElements.define('bz-banner-slider', BzBannerSlider);
}
